import styled from "@emotion/styled";
import { Container, Grid, Typography } from "@mui/material";

const AboutContainer = styled(Container)`
    background-color:#000;
    background-image:url("./assets/about-bg.png");
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
    padding-top:150px;
    padding-bottom:150px;
    @media (max-width: 1024px){
        padding-top:40px;
        padding-bottom:40px;
    }
`
const GridContainer = styled(Grid)`
    @media (min-width: 1537px){ 
        justify-content:center;
        display:flex;
    }
    @media (max-width: 1536px) and (min-width: 600px){
        display:flex;
        justify-content:space-between;
    }
`
const Aboutimg = styled.img`
    width:450px;
    max-width:100%;
    height:auto;
`
const P = styled.p`
    color:#fff;
    font-size:15px;
    font-family:poppins;
`
const Heading = styled(Typography)`
    color:#fff;
    font-size:80px;
    font-family:Oswald-bold;
    @media (max-width: 900px){
        font-size:40px;
    }
`
const LinksWrapper = styled.a`
    display:flex;
    align-items:center;
    margin-right:20px;
    @media (min-width: 900px){
        margin-right:30px;
    }
`
const LinksP = styled.p`
    color:#fff;
    font-family:Oswald-semibold;
    font-size:18px;
    margin-left:10px;
    @media (max-width:350px){
        font-size:11px;
        margin-left:5px;
    }
    @media(max-width: 900px) and (min-width: 350px){
        font-size:12px;
    }
`
const LinksImg = styled.img`
    height:auto;
    width:50px;
    max-width:100%;
    @media(max-width: 900px) and (min-width: 350px){
        height:auto;
        width:35px;
        max-width:100%;
    }
    @media (max-width:350px){
        height:auto;
        width:25px;
        max-width:100%;
    }
`
const LinksContainer = styled.div`
        display:flex;
`
const ImgGrid = styled(Grid)`
    display:flex;
    justify-content:center;
`

function About(){
    return(
        <AboutContainer maxWidth="xxl" id="about">
            <GridContainer container spacing={2}>
                <ImgGrid item xs={12} sm={5}>
                    <div>
                        <Aboutimg src="./assets/wanted.png" />
                    </div>
                </ImgGrid>
                <Grid item xs={12} sm={6} xl={4}>
                    <Heading variant="h1">About</Heading>
                    <P style={{marginTop:"30px"}}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, 
                        sed diam nonumy eirmod tempor invidunt ut labore et dolore 
                        magna aliquyam erat, sed diam voluptua. 
                    </P>
                    <P>At vero eos et accusam et justo duo dolores et ea rebum. Stet
                         clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor
                          sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                           sed diam nonumy eirmod tempor invidunt ut labore et dolore magna 
                           aliquyam erat, sed diam voluptua. At vero eos et accusam et justo 
                           duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata 
                           sanctus est Lorem ipsum dolor sit amet.
                    </P>
                    <P style={{marginBottom:"30px"}}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, 
                        sed diam nonumy eirmod tempor invidunt ut labore et dolore
                         magna aliquyam erat,. 
                    </P>
                    <LinksContainer>
                        <LinksWrapper>
                            <LinksImg src="./assets/ether-logo.png" />
                            <LinksP>Etherscan</LinksP>
                        </LinksWrapper>
                        <LinksWrapper>
                            <LinksImg src="./assets/uniswap-logo.png" />
                            <LinksP>Uniswap</LinksP>
                        </LinksWrapper>
                        <LinksWrapper>
                            <LinksImg src="./assets/dex-logo.png" />
                            <LinksP>DexTools</LinksP>
                        </LinksWrapper>
                    </LinksContainer>
                </Grid>
            </GridContainer>
        </AboutContainer>
    );
}

export default About;